import { COMPONENT_TYPES } from '../../../constants';
import { registerSkinnableComponent } from '../registry';
import { CompanyHistorySkinnable } from './CompanyHistorySkinnable';

// Register CompanyHistory as a skinnable component
registerSkinnableComponent(CompanyHistorySkinnable);

// Export for backward compatibility
export { default as CompanyHistoryComponent } from './CompanyHistory.component';
export { default as CompanyHistoryEditor } from './CompanyHistory.editor';
export { default as CompanyHistoryProperties } from './CompanyHistory.properties';
export * from './CompanyHistory.types';
export { CompanyHistorySkinnable }; 